import { boot } from 'quasar/wrappers'
import { signOut } from 'src/boot/auth'
import { setLocale } from 'src/boot/i18n'
import Me from 'src/graphql/person/Me.gql'
import api from 'src/assets/api/gql'
import store from 'src/assets/store'
import messenger from 'src/assets/messenger'
import { PersonMenu } from 'src/graphql/types'

export default boot(async ({ urlPath }) => {
  try {
    const { data: { me } } = await api.query({
      query: Me
    })
    if (me) {
      setLocale(me.locale)
      store.setPerson(me)
      if (me.profileMenu === null || me.name.trim() === '') {
        if (urlPath !== process.env.VUE_ROUTER_BASE + '') {
          return Promise.reject({ url: process.env.VUE_ROUTER_BASE + '' })
        }
      } else {
        store.setProfile(me.profileMenu)
        if (urlPath === process.env.VUE_ROUTER_BASE + '') {
          if (me.profileMenu === PersonMenu.Presenter) {
            return Promise.reject({ url: process.env.VUE_ROUTER_BASE + 'presenter' })
          } else {
            return Promise.reject({ url: process.env.VUE_ROUTER_BASE + 'attendee' })
          }
        }
      }
      messenger.start()
    } else {
      throw new Error()
    }
  } catch (e) {
    if (!urlPath.startsWith(process.env.VUE_ROUTER_BASE + 'auth') && !urlPath.startsWith(process.env.VUE_ROUTER_BASE + 'guest')) {
      signOut()
    }
  }
})

// @ts-ignore
if (typeof (window.visualViewport) === 'object') {
  const vh1 = window.visualViewport.height * 0.01
  document.documentElement.style.setProperty('--vh1', `${vh1}px`)
  // @ts-ignore
  window.visualViewport.addEventListener('resize', () => {
    // @ts-ignore
    const vh1 = window.visualViewport.height * 0.01
    document.documentElement.style.setProperty('--vh1', `${vh1}px`)
  })
}
